import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Modal, Button } from "@proda-ai/ui-kit";

export const testIds = {
    main: "CloseExtractionModal-modal",
    buttonDiscard: "CloseExtractionModal-button-discard",
};
export type CloseExtractionModalProps = {
    showModal: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    onDiscard: () => void;
};

export const CloseExtractionModal = ({
    showModal,
    onConfirm,
    onCancel,
    onDiscard,
}: CloseExtractionModalProps) => {
    const modalTitle = (
        <Box>
            <Typography variant="body2">
                Are you sure you want to <strong>close extraction?</strong>
            </Typography>
        </Box>
    );

    const footer = (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
            }}
        >
            <Box>
                <Button
                    data-testid={testIds.buttonDiscard}
                    pattern="danger"
                    isGhost={true}
                    size="medium"
                    onClick={onDiscard}
                >
                    Discard Extraction
                </Button>
            </Box>
            <Box sx={{ display: "flex", gap: "8px" }}>
                <Button pattern="secondary" size="medium" onClick={onCancel}>
                    Cancel
                </Button>
                <Button pattern="primary" size="medium" onClick={onConfirm}>
                    Close
                </Button>
            </Box>
        </Box>
    );

    return (
        <Modal
            data-testid={testIds.main}
            open={showModal}
            headerTitle={modalTitle}
            onClose={onCancel}
            footer={footer}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <Typography variant="body3">
                    {`Closing now will save this extraction and any progress completed
                    so far as a 'Draft'.`}
                </Typography>
                <Typography variant="body3" sx={{ color: "var(--proda-red)" }}>
                    Discarding will permanently delete this extraction and
                    cannot be undone.
                </Typography>
            </Box>
        </Modal>
    );
};
